import AuthLoginForm from 'common/components/AuthLoginForm';
import AuthSignupForm from 'common/components/AuthSignupForm';
import Button from 'common/components/Button';
import React from 'react';
import Modal from './Modal';
import { DirectLoginModal, RecommendationLoginModal } from './SquarespaceModal';

export interface AuthFormProps {
    onSuccess: () => void;
    source?: string;
    email?: string;
    showLogin?: boolean;
    signupHeading?: React.ReactNode;
    signupMessage?: React.ReactNode;
    loginHeading?: React.ReactNode;
    loginMessage?: React.ReactNode;
    loginLinkMessage?: React.ReactNode;
    ctaColor?: string;
    ctaMessage?: string;
    showHeaderDivider?: boolean;
    // FIXME: This is too tightly coupled
    modalComponent?: typeof Modal | typeof RecommendationLoginModal | typeof DirectLoginModal;
    postLogin?: () => Promise<void>;
}

interface FormProps {
    title: React.ReactNode;
    onSuccess: () => void;
    email: string;
    onError?: () => null;
    source?: string;
}

interface AuthFormState {
    form: new (props: FormProps) => AuthLoginForm | AuthSignupForm;
}

class AuthForm extends React.Component<AuthFormProps, AuthFormState> {
    constructor(props: AuthFormProps) {
        super(props);
        this.state = {
            form: this.props.showLogin ? AuthLoginForm : AuthSignupForm,
        };
    }

    render() {
        const { onSuccess, email, source, ctaColor, ctaMessage, postLogin } = this.props;
        const Form = this.state.form;
        return (
            <Form
                title={this.renderTitle()}
                onSuccess={onSuccess}
                email={email || ''}
                source={source}
                ctaColor={ctaColor}
                ctaMessage={ctaMessage}
                postLogin={postLogin}
            />
        );
    }

    renderTitle() {
        const { showHeaderDivider } = this.props;
        if (this.state.form === AuthLoginForm) {
            return (
                <div>
                    <div className="heading heading--with-divider heading--h3">
                        {this.props.loginHeading || __('Log in')}
                    </div>
                    <p>{this.props.loginMessage}</p>
                    <div className="paragraph paragraph--soft">
                        {__("Don't have an account?")}{' '}
                        <Button onClick={this.toggleForm} variation="link" typeAttribute="button">
                            {__('Sign up')}
                        </Button>
                    </div>
                </div>
            );
        } else {
            return (
                <div>
                    <div
                        className={`heading ${showHeaderDivider &&
                            'heading--with-divider'} heading--h3`}
                    >
                        {this.props.signupHeading || __('Sign up')}
                    </div>

                    {this.props.signupMessage}

                    <div className="paragraph paragraph--soft">
                        {this.props.loginLinkMessage
                            ? this.props.loginLinkMessage
                            : __('Already have an account?')}{' '}
                        <Button onClick={this.toggleForm} variation="link" typeAttribute="button">
                            {__('Log in')}
                        </Button>
                    </div>
                </div>
            );
        }
    }

    toggleForm = () =>
        this.setState({ form: this.state.form === AuthLoginForm ? AuthSignupForm : AuthLoginForm });
}
export default AuthForm;
